import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService, Core2Config, ApiVisa, ApiResponseModel} from '../../shared';
import { CmsFormSubmissionContainerModel } from '../../../../../../models/aggregates/cms/form';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})

export class CmsFormSubmissionPublicService extends BaseApiTemplateService<CmsFormSubmissionContainerModel> {
    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'form-submissions/public';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'form-submissions/public';
        this.httpClient = http;
      }
    
    public submitWithFile(f: FormData, visa: ApiVisa): Observable<ApiResponseModel<CmsFormSubmissionContainerModel>> {
      return this.httpClient.post<ApiResponseModel<CmsFormSubmissionContainerModel>>(visa.api_domain_url + this.endpoint_path + '/file', f, this.getHttpHeader(visa));
    }
}
